import { EKwikUIProgressSegmentedSize } from "./progress-segmented.definitions";

export const DEFAULT_VALUES = {
  colors: "var(--tui-primary)",
  id: "progress_segmented",
  max: 2,
  size: EKwikUIProgressSegmentedSize.M,
  value: 1
};

export const VALIDATE_KEY_VALUES = {
  colors: true,
  max: true,
  size: true,
  value: true
};
